import { AKF } from "@App/Pages/Partner/AKF";
import { AKFLangzeitMiete } from "@App/Pages/Partner/AKFLangzeitMiete";
import { Alphabet } from "@App/Pages/Partner/Alphabet";
import { Arval } from "@App/Pages/Partner/Arval";
import { ASS } from "@App/Pages/Partner/ASS";
import { Athlon } from "@App/Pages/Partner/Athlon";
import { Autohelden } from "@App/Pages/Partner/Autohelden";
import { Ayvens } from "@App/Pages/Partner/Ayvens";
import { AyvensLight } from "@App/Pages/Partner/AyvensLight";
import { ControlExpert } from "@App/Pages/Partner/ControlExpert";
import { CPM } from "@App/Pages/Partner/CPM";
import { DbConnect } from "@App/Pages/Partner/DbConnect";
import { Demo } from "@App/Pages/Partner/Demo";
import { DeutscheLeasing } from "@App/Pages/Partner/DeutscheLeasing";
import { DeutscheLeasingBosch } from "@App/Pages/Partner/DeutscheLeasingBosch";
import { DHL } from "@App/Pages/Partner/DHL";
import { DieBayerische } from "@App/Pages/Partner/DieBayerische";
import { DieBayerischeSchadenmeldung } from "@App/Pages/Partner/DieBayerischeSchadenmeldung";
import { DKVMobility } from "@App/Pages/Partner/DKVMobility";
import { Ego } from "@App/Pages/Partner/Ego";
import { Finn } from "@App/Pages/Partner/Finn";
import { Fleethub } from "@App/Pages/Partner/Fleethub";
import { GM } from "@App/Pages/Partner/GeneralMotors";
import { Holman } from "@App/Pages/Partner/Holman";
import { Itzehoer } from "@App/Pages/Partner/Itzehoer";
import { Mahle } from "@App/Pages/Partner/Mahle";
import { Mara } from "@App/Pages/Partner/Mara";
import { MeinAuto } from "@App/Pages/Partner/MeinAuto";
import { MFS } from "@App/Pages/Partner/MFS";
import { MfsOpal } from "@App/Pages/Partner/MfsOpal";
import { Mobexo } from "@App/Pages/Partner/Mobexo";
import { MobileGarantie } from "@App/Pages/Partner/MobileGarantie";
import { MobilityConcept } from "@App/Pages/Partner/MobilityConcept";
import { NIO } from "@App/Pages/Partner/NIO";
import { OctopusEV } from "@App/Pages/Partner/OctopusEV";
import { RaiffeisenImpulsDe } from "@App/Pages/Partner/RaiffeisenImpulsDe";
import { Santander } from "@App/Pages/Partner/Santander";
import { SignalIduna } from "@App/Pages/Partner/SignalIduna";
import { Sixt } from "@App/Pages/Partner/Sixt";
import { VehiClever } from "@App/Pages/Partner/VehiClever";
import type { ComponentType } from "react";

export const partnerRoutes: Array<[string, ComponentType]> = [
  ["/partner/akf/*", AKF],
  ["/partner/akf-langzeitmiete/*", AKFLangzeitMiete],
  ["/partner/alphabet/*", Alphabet],
  ["/partner/arval/*", Arval],
  ["/partner/finn/*", Finn],
  ["/partner/fleethub/*", Fleethub],
  ["/partner/dbconnect/*", DbConnect],
  ["/partner/mobility-concept/*", MobilityConcept],
  ["/partner/nio/*", NIO],
  ["/partner/meinauto/*", MeinAuto],
  ["/partner/controlexpert/*", ControlExpert],
  ["/partner/ayvens/*", AyvensLight],
  ["/partner/myald/*", Ayvens],
  ["/partner/deutsche-leasing/*", DeutscheLeasing],
  ["/partner/deutsche-leasing-bosch/*", DeutscheLeasingBosch],
  ["/partner/e-go/*", Ego],
  ["/partner/gme/*", GM],
  ["/partner/vehiclever/*", VehiClever],
  ["/partner/ass/*", ASS],
  ["/partner/athlon/*", Athlon],
  ["/partner/mobexo/*", Mobexo],
  ["/partner/demo/*", Demo],
  ["/partner/signal-iduna/*", SignalIduna],
  ["/partner/santander/*", Santander],
  ["/partner/itzehoer/*", Itzehoer],
  ["/partner/cpm/*", CPM],
  ["/partner/raiffeisen-impuls-de/*", RaiffeisenImpulsDe],
  ["/partner/mahle/*", Mahle],
  ["/partner/sixt/*", Sixt],
  ["/partner/mfs/*", MFS],
  ["/partner/bayerische/*", DieBayerische],
  ["/partner/bayerische-schadenmeldung/*", DieBayerischeSchadenmeldung],
  ["/partner/mobile-garantie/*", MobileGarantie],
  ["/partner/mfs-opal/*", MfsOpal],
  ["/partner/mara/*", Mara],
  ["/partner/holman/*", Holman],
  ["/partner/octopusev/*", OctopusEV],
  ["/partner/autohelden/*", Autohelden],
  ["/partner/dhl/*", DHL],
  ["/partner/dkv-mobility/*", DKVMobility],
];
